import { t as translate } from "../preferences";
import { Plus, Search } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { ClientCard, PageTitle } from "../components/Cards";
import { InitialState, InlineError, useResource } from "../components/DataState";
import { phoneSearchQuery } from "../../../phone";

export function AddClientButton() {
  return <Link to="/mechanic/clients/new" className="m-touch-icon m-bg-primary m-text-primary-foreground" aria-label={translate("Yangi mijoz")}><Plus className="m-size-5" /></Link>;
}

function SearchRow({ query, onChange, add }: { query: string; onChange: (value: string) => void; add: boolean }) {
  return <div className="m-mb-4 m-flex m-items-center m-gap-3"><label className="m-relative m-block m-min-w-0 m-flex-1"><Search className="m-pointer-events-none m-absolute m-left-3 m-top-3.5 m-size-5 m-text-muted" /><span className="m-sr-only">{translate("Mijoz qidirish")}</span><input className="m-text-input m-pl-10" value={query} onChange={(event) => onChange(event.target.value)} placeholder={translate("Ism, telefon yoki raqam")} /></label>{add ? <AddClientButton /> : null}</div>;
}

export function ClientsScreen({ embedded = false }: { embedded?: boolean }) {
  return embedded ? <PagedClientsScreen /> : <AllClientsScreen />;
}

function AllClientsScreen() {
  const resource = useResource(() => api.clients(), []);
  const [query, setQuery] = useState("");
  const clients = resource.data ?? [];
  const needle = phoneSearchQuery(query).toLocaleLowerCase("uz");
  const visible = needle ? clients.filter((client) => `${client.full_name} ${client.phone} ${client.cars.map((car) => car.plate_number).join(" ")}`.toLocaleLowerCase("uz").includes(needle)) : clients;
  return <div>
    <PageTitle title={translate("Mijozlar")} description={translate("Ustaxonadagi barcha mijozlar.")} action={<AddClientButton />} />
    <SearchRow query={query} onChange={setQuery} add={false} />
    <InitialState loading={resource.loading} error={resource.error} empty={!resource.loading && !resource.error && clients.length === 0} onRetry={() => void resource.retry()}>{resource.data ? <><InlineError message={resource.error} onRetry={() => void resource.retry()} />{visible.length ? <div className="m-space-y-3">{visible.map((client) => <ClientCard key={client.id} client={client} />)}</div> : <p className="m-rounded-xl m-bg-elevated m-p-4 m-text-sm m-text-muted">{translate("Qidiruv bo‘yicha mijoz topilmadi.")}</p>}</> : null}</InitialState>
  </div>;
}

function PagedClientsScreen() {
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  useEffect(() => {
    const timer = window.setTimeout(() => setSearch(phoneSearchQuery(query)), 250);
    return () => window.clearTimeout(timer);
  }, [query]);
  const resource = useResource(() => api.clientsOverview(page, search), [page, search]);
  const data = resource.loading ? null : resource.data;
  const pages = Math.max(1, Math.ceil((data?.total ?? 0) / 10));
  function changeQuery(value: string) {
    setQuery(value);
    setPage(1);
  }
  return <div>
    <SearchRow query={query} onChange={changeQuery} add />
    <InitialState loading={resource.loading} error={resource.error} empty={!resource.loading && !resource.error && data?.total === 0 && !search} onRetry={() => void resource.retry()}>{data ? <><InlineError message={resource.error} onRetry={() => void resource.retry()} />{data.items.length ? <div className="m-space-y-3">{data.items.map((client) => <ClientCard key={client.id} client={client} />)}</div> : <p className="m-rounded-xl m-bg-elevated m-p-4 m-text-sm m-text-muted">{translate("Qidiruv bo‘yicha mijoz topilmadi.")}</p>}{data.total > 10 ? <nav className="m-mt-4 m-flex m-items-center m-justify-between m-gap-2" aria-label={translate("Mijozlar")}><button type="button" className="m-secondary-button" disabled={page <= 1 || resource.loading} onClick={() => setPage((n) => n - 1)}>{translate("Oldingi sahifa")}</button><span className="m-text-sm m-text-muted">{page} / {pages}</span><button type="button" className="m-secondary-button" disabled={page >= pages || resource.loading} onClick={() => setPage((n) => n + 1)}>{translate("Keyingi sahifa")}</button></nav> : null}</> : null}</InitialState>
  </div>;
}
